import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { boat_details } from './boats.schema';

export const costs = sqliteTable('costs', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  name: text('name'),
  date: text('date'),
  amount: real('amount'),
  currency_id: integer('currency_id'),
  boat_detail_uuid: text('boat_detail_uuid').references(() => boat_details.id),
  quantity: real('quantity'),
  exchange_rate: real('exchange_rate'),
  category_id: integer('category_id'),
  category_uuid: text('category_uuid'),
  organization_id: text('organization_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  vat_type: text('vat_type'),
  vat_percentage: real('vat_percentage'),
  type: text('type'),
  notes: text('notes'),
  supplier: text('supplier'),
});

export const costables = sqliteTable('costables', {
  id: text('id').notNull().primaryKey(),
  cost_id: integer('cost_id'),
  costable_type: text('costable_type'),
  costable_id: integer('costable_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  cost_uuid: text('cost_uuid'),
  costable_uuid: text('costable_uuid'),
  user_id: integer('user_id'),
  organization_id: text('organization_id'),
});
